import React from 'react';
import { TreeNodeType } from 'src/lib/types/types';
import VNFinanzierungsPlan from './content/VNFinanzierungsPlan';

export const VNTreeStructureFinanzierungsPlan = (_application: any) => {
	let treeNodes: TreeNodeType[] = [
		{
			label: 'Ausgaben und Finanzierungsplan',
			content: <VNFinanzierungsPlan />,
		},
	];

	return treeNodes;
};
